import { SiteType, Trait, TraitsForContext } from '../types';

export const getSiteTraitValues = (traits: Trait[]): TraitsForContext => {
	if (traits.length === 0) {
		return {
			siteType: null,
			automationWeeklyUsage: 0,
			automationDailyUsage: 0,
		};
	}

	const siteTypeTrait = traits.find((trait) => trait.name === 'growth_discount_cohort');

	let siteType = null;
	if (siteTypeTrait) {
		if (siteTypeTrait.value === 'EDU' || siteTypeTrait.value === 'ORG') {
			siteType = siteTypeTrait.value as SiteType;
		} else {
			siteType = 'UNKNOWN' as SiteType;
		}
	}

	// Hard coded limits while we refactor trait loading code
	const automationWeeklyUsage = 0;
	const automationDailyUsage = 0;

	return {
		siteType,
		automationWeeklyUsage,
		automationDailyUsage,
	};
};
